// @mui
import { Theme, SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import TablePagination, { TablePaginationProps } from '@mui/material/TablePagination';
import { useDispatch, useSelector } from 'src/redux/store';
import { setOffset, setRowsPerPage } from 'src/redux/slices/tableSlice';

// ----------------------------------------------------------------------

type Props = {
  dense?: boolean;
  onChangeDense?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps<Theme>;
};

export default function TablePaginationCustom({
  dense,
  onChangeDense,
  rowsPerPageOptions = [1, 5, 10, 25, 50, 100],
  sx,
  ...other
}: Props & TablePaginationProps) {
  const dispatch = useDispatch();
  const { offset, rowsPerOffset, totalRecords } = useSelector((state) => state.table);

  const page = offset / rowsPerOffset;

  return (
    <Box sx={{ position: 'relative', ...sx }}>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        {...other}
        rowsPerPage={rowsPerOffset}
        count={totalRecords}
        onRowsPerPageChange={(data) => dispatch(setRowsPerPage(Number(data.target.value)))}
        onPageChange={(data, e) => dispatch(setOffset(e * rowsPerOffset))}
        page={page}
        sx={{
          borderTopColor: 'transparent',
        }}
      />

      {onChangeDense && (
        <FormControlLabel
          label="Compactar"
          control={<Switch checked={dense} onChange={onChangeDense} />}
          sx={{
            pl: 2,
            py: 1.5,
            top: 0,
            position: {
              sm: 'absolute',
            },
          }}
        />
      )}
    </Box>
  );
}
